import React from "react";
import ServiceStatusValue from "kontrolEdge/components/Shared/ServiceStatusValue";
import { isCarrierAccessEnabled } from "@shared/config/featureFlags";
import { legStatusTag } from "../CarrierAccess/CarrierAccessDetails/carrierAccessLegs";
import { DetailLink } from "../Shared/DetailLink";
import { carrierAccessDetailPath } from "./extenderPopCarrierAccessData";
import { cpeLinkRows } from "./extenderPopCpeLinks";
import type { ExtenderPopCpeDetail } from "./extenderPopDetail.types";

/**
 * The links of a CPE with each carrier's type, status and Carrier Access on
 * the same row, the way the SD-WAN hub lists its branches (CTX-801).
 */
const CpeLinksTable: React.FC<{ cpe: ExtenderPopCpeDetail }> = ({ cpe }) => {
  const rows = cpeLinkRows(cpe.links, cpe.carrierAccess);
  if (rows.length === 0) {
    return (
      <p className="py-1.5 text-sm text-semantic-text-secondary">
        No backbone links detected for this CPE.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-semantic-text-secondary">
            <th className="py-1.5 pr-4 font-normal">Link</th>
            <th className="py-1.5 pr-4 font-normal">Speed</th>
            <th className="py-1.5 pr-4 font-normal">Carrier</th>
            <th className="py-1.5 pr-4 font-normal">Type</th>
            <th className="py-1.5 pr-4 font-normal">Status</th>
            <th className="py-1.5 font-normal">Carrier Access</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const status =
              row.status !== undefined ? legStatusTag(row.status) : null;
            return (
              <tr
                key={row.key}
                className="border-t border-semantic-border-secondary text-semantic-text-primary"
              >
                <td className="py-1.5 pr-4">{row.label}</td>
                <td className="py-1.5 pr-4">{row.speed ?? "-"}</td>
                <td className="py-1.5 pr-4">{row.carrier ?? "-"}</td>
                <td className="py-1.5 pr-4">{row.medium ?? "-"}</td>
                <td className="py-1.5 pr-4">
                  {status ? (
                    <ServiceStatusValue
                      label={status.label}
                      variant={status.variant}
                      tooltip={row.statusMessage ?? undefined}
                    />
                  ) : (
                    "-"
                  )}
                </td>
                <td className="py-1.5">
                  {row.carrierAccess ? (
                    isCarrierAccessEnabled() ? (
                      <DetailLink
                        to={carrierAccessDetailPath(row.carrierAccess.id)}
                        label={row.carrierAccess.serviceId}
                      />
                    ) : (
                      row.carrierAccess.serviceId
                    )
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CpeLinksTable;
